import { NMapRefactored as NMap } from "./Map";
import type { ModelCampaignResponse } from "@models/ModelCampaignResponse";
import { useState, useEffect } from "react";
import { Coordinate } from "@/Components/NMap.tsx";
import MapBadge from "@/Components/Map/MapBadge.tsx";

export type MapSectionProps = {
  latitude?: number;
  longitude?: number;
  currentCampaign?: ModelCampaignResponse;
  coordinates?: Array<{
    naverLink: string
  } & Coordinate>;
};

const MapSection = ({
                      latitude,
                      longitude,
                      currentCampaign,
                      coordinates,
                    }: MapSectionProps) => {

  const [center, setCenter] = useState<Coordinate>({
    latitude: latitude ?? 0,
    longitude: longitude ?? 0,
  });

  useEffect(() => {
    if (coordinates?.length) {
      setCenter(coordinates[0]); // ← Use first point as default center
    } else if (latitude && longitude && latitude > 0 && longitude > 0) {
      setCenter({ latitude, longitude });
    }
  }, [latitude, longitude, coordinates]);

  const markerPoints = coordinates && coordinates?.length > 0 ? coordinates?.map((coord) => {
    return {
      latitude: coord.latitude,
      longitude: coord.longitude,
    }
  }) : []

  return (
    <div className="px-3">
      <div className="flex gap-2 flex-wrap mb-4">
        <h1 className="font-extrabold text-sm">플레이스</h1>
        {
          coordinates && coordinates?.map((coord, i) => (<MapBadge key={i} link={coord.naverLink} number={i+1} />))
        }
      </div>

      <NMap
        center={center}
        zoom={16}
        className="w-full h-[300px] border border-slate-300 rounded mt-2"
        currentCampaign={currentCampaign}
        markerPoints={markerPoints} // ← multiple points
      />
    </div>
  );
};

export default MapSection;
